<template>
  <div class="wrapper">
      <headerBack :backParams="backParams" @backBtn="back()"></headerBack>
       <div class="searchWrap" >
         <div class="searchInfo">
           <van-icon class="searchIcon" size="" name="search" />
           <input placeholder="请输入要查询的线路/站点" class="searchInput" v-model="paramskey.keyword" v-on:input ="searchStation">
         </div>
         <div class="mapSearch" @click="searchStation">
           搜索
         </div>
       </div>
       <div class="ListStyle" v-if="!flag">
            <div class="historyBox">
               <div class="hisName">历史记录</div>
                <div class="deleteName" v-if="historyInfo.length" @click="deleteHistory()">
                <i class="iconfont icon-shanchu"></i>
            </div>
            </div>
            <div class="searchName" >
                    <div class="stationBox" v-for="(ele,index) in historyInfo" :key="index" @click="setInfo(ele)">
                            <div v-if="ele.searchType ==2">
                            <img :src='imgUrl' class="imgIcon" >
                            <span class="title">{{ele.station.stationName}}</span>
                            </div>
                            <div v-if="ele.searchType ==1">
                                <i class="iconfont icon-qiche" style="color:#536ADA;font-size:20px"></i>
                                <span class="title">{{ele.line.lineName}}</span>
                            </div>
                    </div>
            
            </div>
           
       </div>
       <div class="ListStyle"  v-if="flag">
            <div class="searchName" >
                    <div class="stationBox" v-for="(item,index) in staList" :key="index" @click="setInfo(item)">
                            <div v-if="item.searchType ==2">
                              <img :src='imgUrl' class="imgIcon" >
                              <span class="title">{{item.station.stationName}}</span>
                               <!-- <div class="iconfontW iconfont icon-shanchu2" @click.stop="clearItem(item)"></div> -->
                            </div>
                            <div v-if="item.searchType ==1">
                                <img :src='imgUrl' class="imgIcon" >
                                <span class="title">{{item.line.lineName}}</span>
                                 <!-- <div class="iconfontW iconfont icon-shanchu2" @click.stop="clearItem(item)"></div> -->
                            </div>
                    </div>
            
            </div>
       </div>
      
    
  </div>


</template>

<script>
import { setLocalStorage,getLocalStorage,removeLocalStorage} from '../../utils/session'
import headerBack from '@/components/headerBack'
 export default {
  name: "searchPage",
  components: {headerBack},
  data(){
    return{
       paramskey:{
           keyword:''
       },
       backParams:{
         title:'线路/站点查询'
       },
       imgUrl:require('../../assets/image/station.png'),
       staList:[],
       flag:false ,
       historyInfo:[]
     }

   },
  mounted(){
     this.flag = false
     this.historyInfo=getLocalStorage('oldStation') ? getLocalStorage('oldStation'):[]
     this.historyInfo= this.distinct(this.historyInfo)
     this.$wxHide()
  },
  methods:{
    //搜索站点线路
   searchStation(){
       if(this.paramskey.keyword){
           this.$api['station.keywordSearch'](
            this.paramskey
          ).then(res => {
            if(res && res.length){
                this.staList=[]
                this.staList=res.sort(function(a,b){
                    return  a.line ? a.line.lineName.localeCompare( b.line ? b.line.lineName :b.station.stationName,'zh-CN',{ numeric: true}) : a.station.stationName.localeCompare( b.line ? b.line.lineName :b.station.stationName,'zh-CN',{ numeric: true})
                 })
               
            }else{
                this.staList = []
            }
          })
           this.flag= true
       }else{
           this.staList = []
           this.flag= false
       }
      
   },
   //存历史记录
   setInfo(item){
    // 判断是线路 还是站点
    this.saveItem(item)
    if(item.searchType==2){
      //站点
        this.$router.push({name:"stationDetails",params:{station:item.station}})
        this.$session.setSession('line',item.station)
      }else{
      //线路
        this.$router.push({name:"lineDetails",params:{line:item.line,flag:1}})
        this.$session.setSession('line',item.line)
      }
   },
   saveItem (item) {
     this.historyInfo.push(item)
     setLocalStorage('oldStation',this.historyInfo)
   },

   //删除所有的历史记录
   deleteHistory(){
       removeLocalStorage('oldStation')
       this.historyInfo=[]
       this.flag= false
   },
   //删除单条记录
   clearItem(item){
     this.historyInfo= this.historyInfo.filter(ele=>(
         ele.stationId !== item.stationId &&  ele.lineId !== item.lineId
      ))
   },
   back(){
     this.$router.push({name:"home"})
   },
   // 数组去重
    distinct (arr) {
      // console.log(arr)
      for (let i = 0, len = arr.length; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if(arr[i].station && arr[j].station){
            if(arr[i].station.stationName === arr[j].station.stationName) {
               arr.splice(j, 1)
              len--
              j--
            }
          }
          if(arr[i].line && arr[j].line){
             if(arr[i].line.lineName === arr[j].line.lineName) {
               arr.splice(j, 1)
              len--
              j--
            }
          }
         
        }
      }
      return arr
    },

  }
};



</script>
<style lang="scss" scoped>
  .wrapper{
        background: #F8F8F8;
        font-size: 14px;
        width: 100%;
        height: 100%;
        overflow:hidden;
        .searchWrap{
            height: 40px;
            padding: 0.1rem 0px;
            display: flex;
            align-items: center;
            color: #BBBBBB;
            padding: 0.1rem 0.15rem;
            .searchInfo{
              flex: 1 auto;
              display: flex;
              align-items: center;
              padding: 0px 10px;
              height:40px;
              background-color: #fff;
              border-radius:0.32rem;
              .searchInput{
                 border:none;
                 color:#333;
              }
              .searchIcon {
                padding-right: 10px;
                font-size:16px
              }
            }
            .mapSearch {
              width: 0.3rem;
              height: 40px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              font-size:14px;
              color:#333;
              margin-left:0.15rem
            }
          }
        .ListStyle{
            height: calc(100vh - 0.6rem);
            overflow:auto;
            margin-bottom: 0.2rem;
            .historyBox{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding:0.1rem 0.15rem;
              .hisName{
                font-size:18px;
                color:#333;
                font-weight:bold
               }
              .deleteName{
                color: #536ADA;
                font-size:20px
              }
            }
           .searchName{
            margin: 0 0.1rem;
            background: #ffffff;
            box-shadow: 2px 2px 13px 1px #eee;
            border-radius: 6px;
            .stationBox{
                 display: flex;
                 align-items: center;
                 border-bottom: 1px solid #eee;
                 padding: 0.1rem 0rem;
                  margin: 0rem 0.1rem;
                
                 .imgIcon{
                   width:22px;
                   height:22px;
                   position:relative;
                   top:5px;
                  }
                 .title{
                   font-size: 15px;
                   padding-left:0.1rem;
                   color:#333
                 }
              }
             .stationBox:last-child {
                border-bottom: none; 
             }
           }
           
        }
        
         
   }

</style>
    
